import React, { useLayoutEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Software.css';
import Footer from './Footer';
import NavBar from './NavBar';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function Software() {
  const root = useRef(null);
  useLayoutEffect(() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    const ctx = gsap.context(() => {
      const defaultScrollConfig = {
        start: 'top 85%',
        toggleActions: 'play none none none',
      };

      // Hero animation
      const heroTl = gsap.timeline({ defaults: { ease: 'power3.out' } });
      heroTl
        .fromTo(
          '.hero-branch-image',
          { autoAlpha: 0, scale: 1.03 },
          { autoAlpha: 1, scale: 1, duration: 1.1, ease: 'power2.out' }
        )
        .fromTo(
          '.hero-content-software > *',
          { autoAlpha: 0, y: 24 },
          { autoAlpha: 1, y: 0, duration: 0.9, stagger: 0.12 },
          '-=0.6'
        );

      // Intro text
      gsap.fromTo(
        '.intro-text p',
        { autoAlpha: 0, y: 30 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.intro-text',
            ...defaultScrollConfig,
          },
        }
      );

      // Service cards
      gsap.fromTo(
        '.service-card',
        { autoAlpha: 0, y: 60, scale: 0.9, rotateY: -15 },
        {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          rotateY: 0,
          duration: 0.9,
          stagger: 0.2,
          ease: 'back.out(1.4)',
          scrollTrigger: {
            trigger: '.services-grid',
            ...defaultScrollConfig,
          },
        }
      );
    }, root);

    return () => ctx.revert();
  }, []);

  return (
    <div className="Software" ref={root}>
      {/* Header */}
      <NavBar />
      {/* Hero Section */}
      <section className="software-hero">
        <img src="/assets/fondosoftware.png" alt="Branch Development" className="hero-branch-image" />
        <div className="hero-content-software">
          <h1 className="hero-title-software">Desarrollo de Software</h1>
          <p className="hero-subtitle-software">
            Soluciones tecnológicas a medida para impulsar tu negocio
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="content-section">
        <div className="container">
          <div className="intro-text">
            <p>
              En Branch Development, creamos soluciones de software personalizadas que se adaptan
              perfectamente a las necesidades específicas de tu negocio.
            </p>
            <p>
              Nuestro enfoque abarca desde software médico especializado hasta aplicaciones
              empresariales a medida, siempre con los más altos estándares de calidad y seguridad.
            </p>
          </div>

          <div className="services-grid">
            <div className="service-card">
              <div className="service-header">
                <h3>Medicina</h3>
                <div className="service-line"></div>
              </div>
              <p>Software especializado para el sector médico y gestión hospitalaria</p>
              <Link to="/medicina" className="service-link">Ver más</Link>
            </div>

            <div className="service-card">
              <div className="service-header">
                <h3>Tu Idea</h3>
                <div className="service-line"></div>
              </div>
              <p>Transformamos tu idea en el software que tu negocio necesita</p>
              <Link to="/tu-idea" className="service-link">Ver más</Link>
            </div>
          </div>
        </div>       
      </section>

      <Footer />

    </div>
  );
}

export default Software;
